import classNames from 'classnames';
import { useMemo } from 'react';

import { Trans } from 'react-i18next';
import Link from 'next/link';

import { PropsWithClassname } from '@/app/types';
import { Routes } from '@/app/enums';

export enum DonationFormDisclaimerType {
  CHARITY_COLLECTION = 'charity-coolection',
  COMMERCIAL_PROJECT = 'commercial-project',
}
export interface DonationFormDisclaimerProps extends PropsWithClassname {
  type?: DonationFormDisclaimerType;
}

function DonationFormDisclaimer({
  type = DonationFormDisclaimerType.CHARITY_COLLECTION,
  className,
}: DonationFormDisclaimerProps) {
  const i18nKey = useMemo(() => {
    switch (type) {
      case DonationFormDisclaimerType.COMMERCIAL_PROJECT:
        return 'components.CommercialProjectsDonationFormDisclaimer';

      case DonationFormDisclaimerType.CHARITY_COLLECTION:
      default:
        return 'components.DonationFormDisclaimer';
    }
  }, [type]);
  return (
    <div className={classNames('mb-[80px]', className)}>
      <Trans i18nKey={i18nKey}>
        Odesláním příspěvku zároveň souhlasím s{' '}
        <Link
          className="text-primary-mid hover:text-primary-dark underline hover:no-underline"
          href={`${process.env.NEXT_PUBLIC_REDIRECT_URL}/${Routes.TERMS_AND_CONDITIONS}`}
          target="_blank"
          prefetch={process.env.NEXT_PUBLIC_PREFETCH_LINKS === 'true'}
        >
          Pravidly dobročinných sbírek
        </Link>{' '}
        a beru na vědomí{' '}
        <Link
          className="text-primary-mid hover:text-primary-dark underline hover:no-underline"
          href={`${process.env.NEXT_PUBLIC_REDIRECT_URL}/${Routes.PRIVACY_POLICY}`}
          target="_blank"
          prefetch={process.env.NEXT_PUBLIC_PREFETCH_LINKS === 'true'}
        >
          Zásady ochrany osobních údajů.
        </Link>
      </Trans>
    </div>
  );
}

export default DonationFormDisclaimer;
